import { render, staticRenderFns } from "./userMy_userAsset.vue?vue&type=template&id=34606f6f&scoped=true"
import script from "./userMy_userAsset.vue?vue&type=script&lang=js"
export * from "./userMy_userAsset.vue?vue&type=script&lang=js"
import style0 from "./userMy_userAsset.vue?vue&type=style&index=0&id=34606f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34606f6f",
  null
  
)

component.options.__file = "userMy_userAsset.vue"
export default component.exports